export class Micromodal {

    static init() {
        var $ = jQuery;
        //
        if(MicroModal) {
            $('.js-modal-trigger').each(function(index, element) {
                //
                $(element).on('click', function() {
                    var target = $(element).attr('data-custom-open');
                    //
                    MicroModal.show(target);
                })
            })
        }
    }
}